<template>
  <div class="profile">
    <v-container grid-list-md fluid class="pt-0 pb-0">
      <v-card class="pa-2 mb-2 card-r">
      <!--<v-layout row class="pb-2 px-0 ">-->
      <!--<v-flex class="text-xs-right">-->
      <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">edit</v-icon></v-btn>-->
      <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">delete</v-icon></v-btn>-->
      <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">block</v-icon></v-btn>-->
      <!--</v-flex>-->
      <!--</v-layout>-->
      <v-layout row class="px-0">

        <v-flex>
          <v-tabs class="top-tab"
            slot="extension"
            v-model="profileTabs"
            centered
            hide-slider
            fixed-tabs
            color="transparent"
          >
            <v-tabs-slider color="blue"></v-tabs-slider>

            <v-tab to="#TeacherPersonal" class="primary--text f-12 w-20">Teacher Personal</v-tab>
            <v-tab to="#TeacherClasses" class="primary--text f-12 w-20">Classes</v-tab>
            <v-tab to="#Students" class="primary--text f-12 w-20">Students</v-tab>
            <v-tab to="#calender" class="primary--text f-12 w-20">calender</v-tab>
            <v-tab to="#Statistics" class="primary--text f-12 w-20">Class Schedule Management </v-tab>


          </v-tabs>
        </v-flex>
      </v-layout>
      </v-card>
      <v-layout>
        <v-flex>
          <v-tabs-items v-model="profileTabs">
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="TeacherPersonal" >
              <teacher-personal/>
            </v-tab-item>
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="TeacherClasses">
              <TeacherClasses/>
            </v-tab-item>
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="Students">
              <Students/>
            </v-tab-item>
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="calender">
              <calender/>
            </v-tab-item>
            <v-tab-item reverse-transition="fade-transition" transition="fade-transition" id="Statistics">
              <Statistics/>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
  /* eslint-disable */
  import TeacherPersonal from "../teacher/TeacherPersonal";
  // import Calender from "../teacher/Calender";
  import Calender from "@/components/test/NewCalender";

  import Statistics from "../teacher/Statistics";
  import Students from "../teacher/Students";
  import TeacherClasses from "../teacher/TeacherClasses";

  export default {
    name: "AdminProfile",
    data: () => ({
      profileTabs: null,
      TeacherProfile:'',
      
    }),
    components: {
      TeacherPersonal,
      Calender,
      Statistics,
      Students,
      TeacherClasses
    },
    beforeCreate:function(){
      Store.state.teacherClass=[]
      var teacher_id = this.$route.params.id
      Store.dispatch('getTeacherClasses', teacher_id)
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/profile/teacher/TeacherProfile.vue